export class SocialCredential {
    constructor(public email: string, public socialid: string) {}
}
